import axios from 'axios'
import { API_BASE } from 'constants/api.constant';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true
});

export default api